const ThinChevronLeft = ({width = 24, height = 24}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none">
      <path stroke="#212124" strokeLinecap="square" strokeWidth={2} d="m15 4-7 8 7 8" />
    </svg>
  );
};

export default ThinChevronLeft;
